import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent implements OnChanges {

  @Input() fullscreenDiv;
  @Input() height = '90vh';
  @Input() filenameForDownload = '';
  @Input() showBookmarkButton = false;
  @Input() showDownloadButton = true;
  @Input() showFindButton = true;
  @Input() showHandToolButton = true;
  @Input() showOpenFileButton = false;
  @Input() textLayer = true;
  @Input() zoom = 'page-width';
  @Input() base64Src: string;
  @Input() url: string;
  @Input() useIframe: boolean = false;

  showOpenFullscreenBtn = true;
  @ViewChild('fullscreen') divRef;
  fullScreenMode: boolean;
  originalHeight = this.height;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['base64Src']?.currentValue) {
      this.base64Src = changes['base64Src']?.currentValue;
    }
  }

  toggleFullScreen() {
    const elem = this.divRef.nativeElement;

    if (this.showOpenFullscreenBtn) {
      this.height = '100vh';
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullscreen();
        elem.webkitRequestFullScreen(elem.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      this.height = this.originalHeight;
      // alert('Press Ok To Close Fullscreen');
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      // else if (document.mozCancelFullScreen) {
      //   document.mozCancelFullScreen();
      // }
      // else if (document.webkitCancelFullScreen) {
      //   document.webkitCancelFullScreen();
      // }
    }

    this.showOpenFullscreenBtn = !this.showOpenFullscreenBtn;
  }
}
